"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Football = void 0;
const react_1 = __importDefault(require("react"));
const football_1 = __importDefault(require("../icons-path/football"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const Football = (props) => {
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: football_1.default }));
};
exports.Football = Football;
